/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'

// Create Virtual Routes

const PhoneLazyImport = createFileRoute('/phone')()
const HistoryLazyImport = createFileRoute('/history')()
const AudioSettingsLazyImport = createFileRoute('/audio-settings')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const PhoneLazyRoute = PhoneLazyImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/phone.lazy').then((d) => d.Route))

const HistoryLazyRoute = HistoryLazyImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/history.lazy').then((d) => d.Route))

const AudioSettingsLazyRoute = AudioSettingsLazyImport.update({
  id: '/audio-settings',
  path: '/audio-settings',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/audio-settings.lazy').then((d) => d.Route),
)

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/audio-settings': {
      id: '/audio-settings'
      path: '/audio-settings'
      fullPath: '/audio-settings'
      preLoaderRoute: typeof AudioSettingsLazyImport
      parentRoute: typeof rootRoute
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryLazyImport
      parentRoute: typeof rootRoute
    }
    '/phone': {
      id: '/phone'
      path: '/phone'
      fullPath: '/phone'
      preLoaderRoute: typeof PhoneLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/audio-settings': typeof AudioSettingsLazyRoute
  '/history': typeof HistoryLazyRoute
  '/phone': typeof PhoneLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/audio-settings': typeof AudioSettingsLazyRoute
  '/history': typeof HistoryLazyRoute
  '/phone': typeof PhoneLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/audio-settings': typeof AudioSettingsLazyRoute
  '/history': typeof HistoryLazyRoute
  '/phone': typeof PhoneLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/audio-settings' | '/history' | '/phone'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/audio-settings' | '/history' | '/phone'
  id: '__root__' | '/' | '/audio-settings' | '/history' | '/phone'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AudioSettingsLazyRoute: typeof AudioSettingsLazyRoute
  HistoryLazyRoute: typeof HistoryLazyRoute
  PhoneLazyRoute: typeof PhoneLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AudioSettingsLazyRoute: AudioSettingsLazyRoute,
  HistoryLazyRoute: HistoryLazyRoute,
  PhoneLazyRoute: PhoneLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/audio-settings",
        "/history",
        "/phone"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/audio-settings": {
      "filePath": "audio-settings.lazy.tsx"
    },
    "/history": {
      "filePath": "history.lazy.tsx"
    },
    "/phone": {
      "filePath": "phone.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
